var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: {name: 'four_pl.dashboard'},
        }}}),_c('sidebar-item',{attrs:{"link":{
      name: _vm.$t('sidebar.control_tower'),
      icon: 'tim-icons icon-chart-bar-32',
    }}},[_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.kanban'),
        path: {name: 'four_pl.control_tower'},
        isRoute: false,
      }}}),_c('sidebar-item',{attrs:{"link":{
        name:  _vm.$t('sidebar.map'),
        path: {name: 'four_pl.order_in_progress'}
      }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.requests'),
          icon: 'tim-icons icon-basket-simple',
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.request'),
        icon: 'playlist_add_check',
        path: {name: 'four_pl.request'},
        isRoute: false,
      }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.road_map'),
        icon: 'map',
        path: {name: 'four_pl.road_map'},
        isRoute: false,
      }}}):_vm._e()],1),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.shippings'),
          icon: 'tim-icons icon-coins',
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PREMIUM.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.simulation'),
        path: {name: 'four_pl.order_simulation'},
        isRoute: false,
    }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
        name: this.$t('sidebar.quotes'),
        path: {name: 'four_pl.order_quotes'},
        isRoute: false,
      }}}),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PREMIUM.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.approve_table'),
        path: {name: 'four_pl.simulation.approve_table'},
        isRoute: false,
    }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PREMIUM.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.approve_route_table'),
        path: {name: 'four_pl.approve_route_table'},
        isRoute: false,
    }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('pages.order.title.order'),
          icon: 'tim-icons icon-delivery-fast',
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.all_orders'),
          path: {name: 'four_pl.order'}
        }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.canceled'),
          path: {name: 'four_pl.order_canceled'}
    }}}):_vm._e(),_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.address'),
        icon: 'list',
        path: {name: 'four_pl.address_alias'}
      }}})],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.purchase_order'),
          icon: 'tim-icons icon-cart',
        }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.charts'),
          path: {name: 'four_pl.purchase_order_board'}
        }}}),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.add'),
          icon: 'tim-icons icon-cart',
          path: {name: 'four_pl.purchase_order_create'}

        }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.purchase_order'),
          icon: 'tim-icons icon-cart',
          path: {name: 'four_pl.purchase_order'}

        }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.import'),
          icon: 'tim-icons icon-cloud-upload-94',
          path: {name: 'four_pl.imports'}
        }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.exports'),
          icon: 'tim-icons icon-notes',
          path: {name: 'four_pl.purchase_order_exports'}
        }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value,
        _vm.permission.INTEGRA_MANAGER__FINANCIER.value,
        _vm.permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
      ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.reports'),
          icon: 'list',
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.list_documents'),
        path: {name: 'four_pl.orders_documents'},
        isRoute: false,
      }}}):_vm._e(),(_vm.$canAny([
      _vm.permission.INTEGRA_MANAGER__OWNER.value,
      _vm.permission.INTEGRA_MANAGER__ADMIN.value
    ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.orders'),
        icon: 'tim-icons icon-notes',
        path:{name: 'four_pl.order_export'},
      }}}):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value,
        _vm.permission.INTEGRA_MANAGER__FINANCIER.value,
        _vm.permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
      ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PRO.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.canhoto_check'),
        icon: 'assignment_turned_in',
        path: {name: 'four_pl.canhoto'}
      }}}):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PRO.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: 'CTes',
        icon: 'list',
        path: {name: 'four_pl.list_cte'}
      }}}):_vm._e(),(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PRO.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.nf_files'),
        icon: 'assignment_turned_in',
        path: {name: 'four_pl.nf_files'}
      }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.exports_imports'),
          icon: 'tim-icons icon-notes',
        }}},[(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.list_documents'),
        icon: 'tim-icons icon-notes',
        path:{name: 'four_pl.orders_documents_export'},
      }}}):_vm._e(),(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.orders'),
        icon: 'tim-icons icon-notes',
        path:{name: 'four_pl.order_reports'},
      }}}):_vm._e(),(_vm.$canAny([
      _vm.permission.INTEGRA_MANAGER__OWNER.value,
      _vm.permission.INTEGRA_MANAGER__ADMIN.value
    ]))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.transporters'),
        icon: 'tim-icons icon-notes',
        path:{name: 'four_pl.transporters_export'},
      }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PRO.value))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.import_cte'),
        path: {name: 'four_pl.import_cte'},

    }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.users_and_companies'),
          icon: 'group',
          isRoute: false,
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
            name: _vm.$t('sidebar.users'),
            icon: 'group',
            path: {name: 'four_pl.user'},
            isRoute: false,
          }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.transporters'),
            icon: 'tim-icons icon-bus-front-12',
            path: {name: 'four_pl.transporters'},
          }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.drivers'),
            icon: 'tim-icons icon-single-02',
            path: {name: 'four_pl.driver'}
          }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
            name: _vm.$t('sidebar.shippers_customers'),
            icon: 'people_alt',
            path: {name: 'four_pl.customer'}
          }}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }